import createIcon from '../../createIcon';

/**
 * @component @name DiscFull
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTZIMjJWMTRIMjBWMTZaTTIwIDdWMTJIMjJWN0gyMFpNMTAgNEM1LjU4IDQgMiA3LjU4IDIgMTJDMiAxNi40MiA1LjU4IDIwIDEwIDIwQzE0LjQyIDIwIDE4IDE2LjQyIDE4IDEyQzE4IDcuNTggMTQuNDIgNCAxMCA0Wk0xMCAxNEM4LjkgMTQgOCAxMy4xIDggMTJDOCAxMC45IDguOSAxMCAxMCAxMEMxMS4xIDEwIDEyIDEwLjkgMTIgMTJDMTIgMTMuMSAxMS4xIDE0IDEwIDE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DiscFull = createIcon('DiscFull', [
  [
    'path',
    {
      d: 'M20 16H22V14H20V16ZM20 7V12H22V7H20ZM10 4C5.58 4 2 7.58 2 12C2 16.42 5.58 20 10 20C14.42 20 18 16.42 18 12C18 7.58 14.42 4 10 4ZM10 14C8.9 14 8 13.1 8 12C8 10.9 8.9 10 10 10C11.1 10 12 10.9 12 12C12 13.1 11.1 14 10 14Z',
      key: 'wvk8jl',
    },
  ],
]);

export default DiscFull;
